export const COOKIE_KEYS = {
	SKIP_ONBOARDING: "skip-starter-onboarding",
};

export function setCookie(name: string, value: string, days = 7) {
	const date = new Date();
	date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	const expires = `; expires=${date.toUTCString()}`;
	// biome-ignore lint/suspicious/noDocumentCookie: helper utilitário de cookie
	document.cookie = `${name}=${value || ""}${expires}; path=/; SameSite=Lax`;
}

export function getCookie(name: string) {
	const nameEQ = `${name}=`;
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function deleteCookie(name: string) {
	// biome-ignore lint/suspicious/noDocumentCookie: helper utilitário de cookie
	document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
